export const macArmOptions = ['M1', 'M2', 'M3', 'M4'];
